import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Capacitor } from '@capacitor/core';

import { Delivery } from 'app/core/models';
import * as rootReducer from 'app/core/store/reducers';
import { PlatformService } from 'app/core/services/platform.service';
import { removeOfflineDelivery } from 'app/core/store/actions';

@Component({
  standalone: false,
  selector: 'pptl-modal-offline-delivery',
  templateUrl: './modal-offline-delivery.component.html',
  styleUrls: ['./modal-offline-delivery.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalOfflineDeliveryComponent {
  noTrack = '/assets/images/no-track.jpg';
  delivery: Delivery;
  isLoading$: Observable<boolean>;

  constructor(
    private modalController: ModalController,
    private domSanitizer: DomSanitizer,
    private router: Router,
    private store: Store<rootReducer.State>,
    private platformService: PlatformService,
  ) {}

  onCancelButtonClick(): void {
    this.dismissModal();
  }

  dismissModal(): void {
    this.modalController.dismiss();
  }

  getDeliveryImageUrl(delivery: Delivery): SafeResourceUrl {
    let imageUrl = this.isMobile ? delivery.deliveryImage : delivery.mobileDeliveryImage;
    if (this.isDevicePlatform && !this.isDesktop) {
      imageUrl = Capacitor
        .convertFileSrc(delivery.mobileDeliveryImage)
        .replace('undefined/', '');
    }
    const url: SafeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(imageUrl);
    if (this.isMobile) {
      return delivery.mobileDeliveryImage === this.noTrack ? this.noTrack : url;
    }

    return delivery.deliveryImage;
  }

  imgLoadedErr(delivery) {
    const errDelivery = delivery;

    errDelivery.deliveryImage = this.noTrack;
    errDelivery.mobileDeliveryImage = this.noTrack;
  }

  onRemoveFileClick(deliveryKeyCode: string): void {
    this.store.dispatch(removeOfflineDelivery({ deliveryKeyCode }));
    this.router.navigate(['/offline']);
    this.dismissModal();
  }

  onReactivateClick(): void {
    this.dismissModal();
  }

  get isDevicePlatform(): boolean {
    return this.platformService.isCordova();
  }

  get isMobile(): boolean {
    return this.platformService.isMobile();
  }

  get isDesktop(): boolean {
    return this.platformService.isDesktop();
  }
}
